export const UNLIMITED_VALUE = 'unlimited';
